import React, { useEffect, useState } from "react";
import { Chart } from 'react-google-charts';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import { Bar } from "react-chartjs-2";
import NoData from './NoData';
import ChartLoader from './ChartLoader';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    scales,
    Ticks
  } from "chart.js";
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  ChartJS.register(ChartDataLabels);

  let MaxchartdataA
  let MaxchartdataB
  let MaxchartdataC
  let MaxchartdataD
  let res_resultA = [];
  let res_resultB = [];
  let res_resultC = [];
  let res_resultD = [];

export default function PdfEigthPage(props) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    let { title, template_id, show, soarting, gloablfilter, IND } = props;

    const [apiresponceA, SetApiResponceA] = useState([]);
    const [apiresponceB, SetApiResponceB] = useState([]);
    const [apiresponceC, SetApiResponceC] = useState([]);
    const [apiresponceD, SetApiResponceD] = useState([]);
    const [chartdataA, setChartDataA] = useState([]);
    const [chartdataB, setChartDataB] = useState([]);
    const [chartdataC, setChartDataC] = useState([]);
    const [chartdataD, setChartDataD] = useState([]);

    useEffect(() => {
        fetchData({ url: API_URL_MAIN + "charging_api_bus/max_cell_temp_vehicles", body: { filterdata: gloablfilter, maxCellTemp_Option: "A_Max_Cell_Temp" } }, appyDataVehiclesA)
        fetchData({ url: API_URL_MAIN + "charging_api_bus/max_cell_temp_vehicles", body: { filterdata: gloablfilter, maxCellTemp_Option: "B_Max_Cell_Temp" } }, appyDataVehiclesB)
        fetchData({ url: API_URL_MAIN + "charging_api_bus/max_cell_temp_vehicles", body: { filterdata: gloablfilter, maxCellTemp_Option: "C_Max_Cell_Temp" } }, appyDataVehiclesC)
        fetchData({ url: API_URL_MAIN + "charging_api_bus/max_cell_temp_vehicles", body: { filterdata: gloablfilter, maxCellTemp_Option: "D_Max_Cell_Temp" } }, appyDataVehiclesD)
    }, [gloablfilter])

    const appyDataVehiclesA = (data) => {
        res_resultA = []
        res_resultA = data;
        let responce = {
          "<=20": 0,
          "22": 0,
          "24": 0,
          "26": 0,
          "28": 0,
          "30": 0,
          "32": 0,
          "34": 0,
          "36": 0,
          "38": 0,
          "40": 0,
          "42": 0,
          "44": 0,
          ">44": 0,
        };
        if (res_resultA.length !== 0) {
          let temp_result = res_resultA;
          let id = 0
          let newapiarray = []
          SetApiResponceA(res_resultA)
          temp_result.map(d => {
            let value = d["A_Max_Cell_Temp"].value;
            if (value != null) {
              if (value > 0 && value <= 20) {
                responce["<=20"] = responce["<=20"] + 1;
              } else if (value > 20 && value <= 22) {
                responce["22"] = responce["22"] + 1;
              } else if (value > 22 && value <= 24) {
                responce["24"] = responce["24"] + 1;
              } else if (value > 24 && value <= 26) {
                responce["26"] = responce["26"] + 1;
              } else if (value > 26 && value <= 28) {
                responce["28"] = responce["28"] + 1;
              } else if (value > 28 && value <= 30) {
                responce["30"] = responce["30"] + 1;
              } else if (value > 30 && value <= 32) {
                responce["32"] = responce["32"] + 1;
              } else if (value > 32 && value <= 34) {
                responce["34"] = responce["34"] + 1;
              } else if (value > 34 && value <= 36) {
                responce["36"] = responce["36"] + 1;
              } else if (value > 36 && value <= 38) {
                responce["38"] = responce["38"] + 1;
              } else if (value > 38 && value <= 40) {
                responce["40"] = responce["40"] + 1;
              } else if (value > 40 && value <= 42) {
                responce["42"] = responce["42"] + 1;
              } else if (value > 42 && value <= 44) {
                responce["44"] = responce["44"] + 1;
              } else if (value > 44) {
                responce[">44"] = responce[">44"] + 1;
              }
            }
          })
    
          let res_result_final = [["Element", "Count", { role: "style" }]]
          const loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          let countcheck = 0
          for (const key in responce) {
            if (responce[key] > 0) {
              countcheck = countcheck + 1
            }
          }
    
          loop_keys.map(x => {
            if (countcheck)
              // "#83A4CF"
              res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
          })
    
          const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          MaxchartdataA = {
            labels,
            datasets: [
              {
                label: "deg Celcius",
                data: Object.values(responce),
                backgroundColor: "#83A4CF",
                borderWidth: 1,
                borderColor: "black",
              },
            ]
          };
          setChartDataA((prestate) => res_result_final);
        } else {
          setChartDataA((prestate) => []);
        }
    }

    const appyDataVehiclesB = (data) => {
        res_resultB = []
        res_resultB = data;
        let responce = {
          "<=20": 0,
          "22": 0,
          "24": 0,
          "26": 0,
          "28": 0,
          "30": 0,
          "32": 0,
          "34": 0,
          "36": 0,
          "38": 0,
          "40": 0,
          "42": 0,
          "44": 0,
          ">44": 0,
        };
        if (res_resultB.length !== 0) {
          let temp_result = res_resultB;
          let id = 0
          let newapiarray = []
          SetApiResponceB(res_resultB)
          temp_result.map(d => {
            let value = d["B_Max_Cell_Temp"].value;
            if (value != null) {
              if (value > 0 && value <= 20) {
                responce["<=20"] = responce["<=20"] + 1;
              } else if (value > 20 && value <= 22) {
                responce["22"] = responce["22"] + 1;
              } else if (value > 22 && value <= 24) {
                responce["24"] = responce["24"] + 1;
              } else if (value > 24 && value <= 26) {
                responce["26"] = responce["26"] + 1;
              } else if (value > 26 && value <= 28) {
                responce["28"] = responce["28"] + 1;
              } else if (value > 28 && value <= 30) {
                responce["30"] = responce["30"] + 1;
              } else if (value > 30 && value <= 32) {
                responce["32"] = responce["32"] + 1;
              } else if (value > 32 && value <= 34) {
                responce["34"] = responce["34"] + 1;
              } else if (value > 34 && value <= 36) {
                responce["36"] = responce["36"] + 1;
              } else if (value > 36 && value <= 38) {
                responce["38"] = responce["38"] + 1;
              } else if (value > 38 && value <= 40) {
                responce["40"] = responce["40"] + 1;
              } else if (value > 40 && value <= 42) {
                responce["42"] = responce["42"] + 1;
              } else if (value > 42 && value <= 44) {
                responce["44"] = responce["44"] + 1;
              } else if (value > 44) {
                responce[">44"] = responce[">44"] + 1;
              }
            }
          })
    
          let res_result_final = [["Element", "Count", { role: "style" }]]
          const loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          let countcheck = 0
          for (const key in responce) {
            if (responce[key] > 0) {
              countcheck = countcheck + 1
            }
          }
    
          loop_keys.map(x => {
            if (countcheck)
              // "#83A4CF"
              res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
          })
    
          const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          MaxchartdataB = {
            labels,
            datasets: [
              {
                label: "deg Celcius",
                data: Object.values(responce),
                backgroundColor: "#83A4CF",
                borderWidth: 1,
                borderColor: "black",
              },
            ]
          };
          setChartDataB((prestate) => res_result_final);
        } else {
            setChartDataB((prestate) => []);
        }
    }

    const appyDataVehiclesC = (data) => {
        res_resultC = []
        res_resultC = data;
        let responce = {
          "<=20": 0,
          "22": 0,
          "24": 0,
          "26": 0,
          "28": 0,
          "30": 0,
          "32": 0,
          "34": 0,
          "36": 0,
          "38": 0,
          "40": 0,
          "42": 0,
          "44": 0,
          ">44": 0,
        };
        if (res_resultC.length !== 0) {
          let temp_result = res_resultC;
          let id = 0
          let newapiarray = []
          SetApiResponceC(res_resultB)
          temp_result.map(d => {
            let value = d["C_Max_Cell_Temp"].value;
            if (value != null) {
              if (value > 0 && value <= 20) {
                responce["<=20"] = responce["<=20"] + 1;
              } else if (value > 20 && value <= 22) {
                responce["22"] = responce["22"] + 1;
              } else if (value > 22 && value <= 24) {
                responce["24"] = responce["24"] + 1;
              } else if (value > 24 && value <= 26) {
                responce["26"] = responce["26"] + 1;
              } else if (value > 26 && value <= 28) {
                responce["28"] = responce["28"] + 1;
              } else if (value > 28 && value <= 30) {
                responce["30"] = responce["30"] + 1;
              } else if (value > 30 && value <= 32) {
                responce["32"] = responce["32"] + 1;
              } else if (value > 32 && value <= 34) {
                responce["34"] = responce["34"] + 1;
              } else if (value > 34 && value <= 36) {
                responce["36"] = responce["36"] + 1;
              } else if (value > 36 && value <= 38) {
                responce["38"] = responce["38"] + 1;
              } else if (value > 38 && value <= 40) {
                responce["40"] = responce["40"] + 1;
              } else if (value > 40 && value <= 42) {
                responce["42"] = responce["42"] + 1;
              } else if (value > 42 && value <= 44) {
                responce["44"] = responce["44"] + 1;
              } else if (value > 44) {
                responce[">44"] = responce[">44"] + 1;
              }
            }
          })
    
          let res_result_final = [["Element", "Count", { role: "style" }]]
          const loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          let countcheck = 0
          for (const key in responce) {
            if (responce[key] > 0) {
              countcheck = countcheck + 1
            }
          }
    
          loop_keys.map(x => {
            if (countcheck)
              // "#83A4CF"
              res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
          })
    
          const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          MaxchartdataC = {
            labels,
            datasets: [
              {
                label: "deg Celcius",
                data: Object.values(responce),
                backgroundColor: "#83A4CF",
                borderWidth: 1,
                borderColor: "black",
              },
            ]
          };
          setChartDataC((prestate) => res_result_final);
        } else {
            setChartDataC((prestate) => []);
        }
    }

    const appyDataVehiclesD = (data) => {
        res_resultD = []
        res_resultD = data;
        let responce = {
          "<=20": 0,
          "22": 0,
          "24": 0,
          "26": 0,
          "28": 0,
          "30": 0,
          "32": 0,
          "34": 0,
          "36": 0,
          "38": 0,
          "40": 0,
          "42": 0,
          "44": 0,
          ">44": 0,
        };
        if (res_resultD.length !== 0) {
          let temp_result = res_resultD;
          let id = 0
          let newapiarray = []
          SetApiResponceD(res_resultB)
          temp_result.map(d => {
            let value = d["D_Max_Cell_Temp"].value;
            if (value != null) {
              if (value > 0 && value <= 20) {
                responce["<=20"] = responce["<=20"] + 1;
              } else if (value > 20 && value <= 22) {
                responce["22"] = responce["22"] + 1;
              } else if (value > 22 && value <= 24) {
                responce["24"] = responce["24"] + 1;
              } else if (value > 24 && value <= 26) {
                responce["26"] = responce["26"] + 1;
              } else if (value > 26 && value <= 28) {
                responce["28"] = responce["28"] + 1;
              } else if (value > 28 && value <= 30) {
                responce["30"] = responce["30"] + 1;
              } else if (value > 30 && value <= 32) {
                responce["32"] = responce["32"] + 1;
              } else if (value > 32 && value <= 34) {
                responce["34"] = responce["34"] + 1;
              } else if (value > 34 && value <= 36) {
                responce["36"] = responce["36"] + 1;
              } else if (value > 36 && value <= 38) {
                responce["38"] = responce["38"] + 1;
              } else if (value > 38 && value <= 40) {
                responce["40"] = responce["40"] + 1;
              } else if (value > 40 && value <= 42) {
                responce["42"] = responce["42"] + 1;
              } else if (value > 42 && value <= 44) {
                responce["44"] = responce["44"] + 1;
              } else if (value > 44) {
                responce[">44"] = responce[">44"] + 1;
              }
            }
          })
    
          let res_result_final = [["Element", "Count", { role: "style" }]]
          const loop_keys = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          let countcheck = 0
          for (const key in responce) {
            if (responce[key] > 0) {
              countcheck = countcheck + 1
            }
          }
    
          loop_keys.map(x => {
            if (countcheck)
              // "#83A4CF"
              res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
          })
    
          const labels = ["<=20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44", ">44"]
          MaxchartdataD = {
            labels,
            datasets: [
              {
                label: "deg Celcius",
                data: Object.values(responce),
                backgroundColor: "#83A4CF",
                borderWidth: 1,
                borderColor: "black",
              },
            ]
          };
          setChartDataD((prestate) => res_result_final);
        } else {
            setChartDataD((prestate) => []);
        }
    }

    const options1 = {
        responsive: true,
        categoryPercentage: 1.0,
        barPercentage: 1.0,
        scales: {
          x: {
            grid: {
                display: false,
                color: 'white',
            },
            title: {
              display: true,
              text: 'deg Celcius(°C)'
            },
            suggestedMin: 0,
            ticks: {
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,
            }
          },
    
          y: {
            grid: {
                display: false,
              color: 'white',
            },
            title: {
              display: true,
              text: 'Vehicle Count'
            },
            suggestedMin: 0,
          },
        },
    
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: false
        },
        // Manually draw data labels on top of bars
      datalabels: {
        color: 'black', // color of the data labels
        anchor: 'end', // position of the data labels
        align: 'end', // alignment of the data labels
        // rotation: 270,
        font: {
          weight: '', // make the text bold
        },
        formatter: function (value, context) {
          return Number(value) // format how the data labels appear
        }
      },
        },
        
    }

  return (
    <div className="eightpage">
        <div className="row" style={{justifyContent:"end"}}>
            <img src='../../../assets/img_Bus/Pdf_Page/Tatamotors.png' alt='' style={{height:"80px", width:"250px"}}/>
        </div>
        <div className='row mt-2'>
          <div className="col-md-9">
          <span className="text-left" style={{color:"#002060", paddingLeft:"40px", fontSize:"16px", fontWeight:"bolder", }}>Pack wise max temperature vs vehicle count :</span>
          <span className="text-right" style={{color:"#002060", fontSize:"12px" }}>{props.startdate} - {props.enddate}</span>
          </div>
        </div>

        <div className="row mt-3">
            <div className="row">
                <div className="col-md-4" style={{paddingLeft:"40px", paddingRight:"0px"}}>
                {
                  (isLoading) ? <ChartLoader /> : 
                  (chartdataA.length > 1) ?
                  <>
                  <div id ="pack_a">
                    <div style={{border:"1px solid #E0E0E0", backgroundColor:"#E0E0E0", borderRadius:"3px", color:"black", width:"60px", marginLeft:"55px"}}>Pack A</div>
                    <Bar options={options1} data={MaxchartdataA} width="70px" height="55px" />
                  </div>
                  </> :<div id ='pack_a_no_data'> <NoData /></div>
                }
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-4" style={{paddingLeft:"40px", paddingRight:"0px"}}>
                  {
                    (isLoading) ? <ChartLoader /> : 
                    (chartdataB.length > 1) ?
                    <>
                    <div id ='pack_b'>
                    <div style={{border:"1px solid #E0E0E0", backgroundColor:"#E0E0E0", borderRadius:"3px", color:"black", width:"60px", marginLeft:"55px", justifyContent:"center"}}>Pack B</div>
                    <Bar options={options1} data={MaxchartdataB} width="70px" height="55px" />
                    </div>
                    </> : <div id ='pack_b_no_data'><NoData /></div>
                }
                </div>
            </div>
        </div>

        <div className="row mt-4">
            <div className="row">
                <div className="col-md-4" style={{paddingLeft:"40px", paddingRight:"0px"}}>
                {
                    (isLoading) ? <ChartLoader /> : 
                    (chartdataC.length > 1) ?
                    <>
                    <div id='pack_c'>
                    <div style={{border:"1px solid #E0E0E0", backgroundColor:"#E0E0E0", borderRadius:"3px", color:"black", width:"60px", marginLeft:"55px"}}>Pack C</div>
                    <Bar options={options1} data={MaxchartdataC} width="70px" height="55px" />
                    </div>
                    </> : <div id ='pack_c_no_data'><NoData /></div>
                }
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-4" style={{paddingLeft:"40px", paddingRight:"0px"}}>
                {
                    (isLoading) ? <ChartLoader /> : 
                    (chartdataD.length > 1) ?
                    <>
                    <div id = 'pack_d'>
                    <div style={{border:"1px solid #E0E0E0", backgroundColor:"#E0E0E0", borderRadius:"3px", color:"black", width:"60px", marginLeft:"55px"}}>Pack D</div>
                    <Bar options={options1} data={MaxchartdataD} width="70px" height="55px" />
                    </div>
                    </> : <div id ='pack_d_no_data'> <NoData /></div>
                }
                </div>
            </div>
        </div>

        <div className='row bottomcontent pl-4' style={{paddingTop:"60px"}}>
          <div className='col-md-3'>
            <img src='../../../assets/img_Bus/Pdf_Page/footer.png' alt='' style={{height:"70px", width:"200px"}}/>
          </div>
          <div className='col-md-1'></div>
          <div className='col-md-4'>
            <p style={{fontSize:"11px", paddingTop:"60px", paddingLeft:"10px"}}>Copyright, Confidential, Tata Motors Limited</p>
          </div>
        </div>
    </div>
  )
}
